export const TABLE_UPDATE = "ACCOUNT_APPLICATIONS/TABLE_UPDATE";
export const FETCH_SUCCESS = "ACCOUNT_APPLICATIONS/FETCH_SUCCESS";
export const FETCH_ALL_SUCCESS = "ACCOUNT_APPLICATIONS/FETCH_ALL_SUCCESS"
const types = {
    DESTROY_FAILED: "ACCOUNT_APPLICATIONS/DESTROY_FAILED",
    DESTROY_REQUEST: "ACCOUNT_APPLICATIONS/DESTROY_REQUEST",
    DESTROY_SUCCESS: "ACCOUNT_APPLICATIONS/DESTROY_SUCCESS",

    FETCH_FAILED: "ACCOUNT_APPLICATIONS/FETCH_FAILED",
    FETCH_REQUEST: "ACCOUNT_APPLICATIONS/FETCH_REQUEST",
    FETCH_SUCCESS,

    FETCH_ALL_FAILED: "ACCOUNT_APPLICATIONS/FETCH_ALL_FAILED",
    FETCH_ALL_REQUEST: "ACCOUNT_APPLICATIONS/FETCH_ALL_REQUEST",
    FETCH_ALL_SUCCESS,

    GET_FAILED: "ACCOUNT_APPLICATIONS/GET_FAILED",
    GET_REQUEST: "ACCOUNT_APPLICATIONS/GET_REQUEST",
    GET_SUCCESS: "ACCOUNT_APPLICATIONS/GET_SUCCESS",

    PATCH_FAILED: "ACCOUNT_APPLICATIONS/PATCH_FAILED",
    PATCH_REQUEST: "ACCOUNT_APPLICATIONS/PATCH_REQUEST",
    PATCH_SUCCESS: "ACCOUNT_APPLICATIONS/PATCH_SUCCESS",
    
    STORE_FAILED: "ACCOUNT_APPLICATIONS/STORE_FAILED",
    STORE_REQUEST: "ACCOUNT_APPLICATIONS/STORE_REQUEST",
    STORE_SUCCESS: "ACCOUNT_APPLICATIONS/STORE_SUCCESS",

    UPDATE_FAILED: "ACCOUNT_APPLICATIONS/UPDATE_FAILED",
    UPDATE_REQUEST: "ACCOUNT_APPLICATIONS/UPDATE_REQUEST",
    UPDATE_SUCCESS: "ACCOUNT_APPLICATIONS/UPDATE_SUCCESS",
    TABLE_UPDATE,
};

export default types;
